import { Clock } from 'lucide-react'
import type { ReactNode } from 'react'
import '../GameweekGrid.css'

/**
 * The grid header's deadline line, plus its rules ⓘ. Split out of `GameweekGridHeader` by ticket
 * Markup unchanged. Pure: the caller supplies an already-computed label, so nothing here
 * reads a clock.
 *
 * The rules screen no longer renders this (the frozen countdown claimed an urgency a rules page
 * shouldn't), so the grid header is its only consumer; it stays split out because the header is
 * better off without the markup.
 */
export default function DeadlineCountdownLine({
  label,
  isUrgent,
  info,
}: {
  label: string
  isUrgent: boolean
  /** The rules ⓘ — the one contextual ⓘ left in the app. */
  info?: ReactNode
}) {
  return (
    <p
      className={`gameweek-grid__countdown ${
        isUrgent ? 'gameweek-grid__countdown--urgent' : ''
      }`}
    >
      <Clock className="gameweek-grid__countdown-icon" aria-hidden="true" />
      {label}
      {info}
    </p>
  )
}
